import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Flex, Box } from 'pcln-design-system'
import SizableIcon from './SizableIcon'

const LargerCentered = styled(Flex)`
  justify-content: flex-end;
  ${(props) => props.theme.mediaQueries.sm} {
    justify-content: center;
  }

  visibility: ${({ visibility }) => visibility};
`

const LargerIcon = styled(Box)`
  display: none;
  ${(props) => props.theme.mediaQueries.sm} {
    display: inline;
  }
`

const MobileIcon = styled(Box)`
  ${(props) => props.theme.mediaQueries.sm} {
    display: none;
  }
`

const IconRow = ({ ancillaries, visibility, ...props }) => {
  return (
    <LargerCentered mt={1} visibility={visibility} {...props}>
      {ancillaries.map((ancillary) => (
        <React.Fragment key={ancillary.name}>
          {/* onClick prevents tooltip click from selecting listing */}
          <MobileIcon data-testid={`ancillary-mobile-icon-wrapper-${ancillary.name.toLowerCase()}`} m='2px'>
            <SizableIcon size={ancillary.size || 16} ancillary={ancillary} />
          </MobileIcon>
          <LargerIcon
            key={ancillary.name}
            m={1}
            data-testid={`ancillary-desktop-icon-wrapper-${ancillary.name.toLowerCase()}`}
          >
            <SizableIcon size={ancillary.desktopSize || 18} ancillary={ancillary} />
          </LargerIcon>
        </React.Fragment>
      ))}
    </LargerCentered>
  )
}

IconRow.defaultProps = {
  ancillaries: [],
  visibility: 'visible',
}

IconRow.propTypes = {
  ancillaries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      description: PropTypes.string,
      inclusion: PropTypes.string,
      size: PropTypes.number,
      desktopSize: PropTypes.number,
    })
  ),
  visibility: PropTypes.string,
}

export default IconRow
